import { useState } from "react";
import { useAuthenticate } from "../context/AuthContext";
import axios from "axios";
import { api_url } from "../utils/data";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

export const useAttendance = () => {
  const { authToken } = useAuthenticate();
  const [takingAttendance, setTakingAttendance] = useState(false);

  const handleLocationError = () => {
    toast.error("Please allow access to your location");
  };

  const handleApiError = (error) => {
    setTakingAttendance(false);
    if (error?.response?.status === 500) {
      return toast.error("Internal server error");
    }
    if (error?.response?.status === 400) {
      for (const property in error.response.data) {
        if (property !== "0") {
          toast.error(`${property} error: ${error.response.data[property]}`);
        } else {
          toast.error(`${error.response.data[property]}`);
        }
      }
    } else {
      toast.error("Something went wrong");
    }
  };

  const processAttendance = async (position, endpoint, isCheckOut = false) => {
    const accuracy = position.coords.accuracy;

    if (accuracy < 2000) {
      setTakingAttendance(false);
      Swal.fire({
        icon: "error",
        title: "Inaccurate position",
        text: "We are not getting your accurate position. Please pin your location in google maps and try again.",
      });
      return;
    }

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
    };

    const body = JSON.stringify({
      longitude: position.coords.longitude,
      latitude: position.coords.latitude,
    });

    try {
      const response = await axios[isCheckOut ? 'put' : 'post'](endpoint, body, config);
      
      setTakingAttendance(false);
      const alertCallback = isCheckOut ? () => window.location.reload() : undefined;
      
      Swal.fire({
        icon: response.data.icon,
        title: response.data.title,
        text: response.data.text,
      }).then(alertCallback);
      
    } catch (error) {
      handleApiError(error);
    }
  };

  const checkIn = () => {
    if (!navigator.geolocation) {
      toast.error("Your browser does not support this feature, please use a different browser.");
      return;
    }

    const watchId = navigator.geolocation.watchPosition(
      (position) => {
        setTakingAttendance(true);
        navigator.geolocation.clearWatch(watchId);
        processAttendance(position, `${api_url}/staff-management/attendance/check-in/`);
      },
      handleLocationError
    );
  };

  const checkOut = () => {
    if (!navigator.geolocation) {
      toast.error("Your browser does not support this feature, please use a different browser.");
      return;
    }

    const watchId = navigator.geolocation.watchPosition(
      (position) => {
        setTakingAttendance(true);
        navigator.geolocation.clearWatch(watchId);
        processAttendance(position, `${api_url}/staff-management/attendance/check-out/`, true);
      },
      handleLocationError
    );
  };

  return {
    takingAttendance,
    checkIn,
    checkOut
  };
};